import { useParams } from 'react-router-dom';
import { useGoToPath } from 'catering/hooks/navigation/useGoToPath';
import { buildCartItemPath } from 'catering/helpers/paths';

export function useGoToCartItem() {
  const { locationSlug } = useParams();
  const { go } = useGoToPath();
  return (cartItemId, isRedirect = false) =>
    go({ path: buildCartItemPath(locationSlug, cartItemId), isRedirect });
}
